import { PROCEDURE_MAX_FILE_SIZE } from "@graffer-inc/cloud-gov-core";

export type FileSizeIndicatorProps = {
  totalFileSize: number;
};

export const TotalFileSizeIndicator: React.FC<FileSizeIndicatorProps> = ({
  totalFileSize,
}) => {
  return (
    <div className="notification is-link is-light">
      <div>
        {`保存済みの最大サイズの合計 : `}
        <span className="has-text-weight-bold">{`${totalFileSize}MB`}</span>
        {` / ${PROCEDURE_MAX_FILE_SIZE}MB`}
      </div>
    </div>
  );
};
